import React from 'react';
import { APITypes } from '../../../primary-record-types';
import * as Card from '../../v2BaseComponents/Card';
import { reportTypeMessages } from '../../../utils/sharedMessages';
import { getIntl } from '../../../utils/intl';
import getDateString from '../../../utils/getDateString';
import { useReports } from '../../../hooks/api/useReports';

const intl = getIntl('sharedReportCard', {
    created: 'Created on: {date}',
    views: '{count} View{plural}',
});

export type SharedReportCardOwnProps = {
    sharedReport: APITypes.reportService.SharedReportItem;
    onPress?: () => void;
};

export type SharedReportCardProps = SharedReportCardOwnProps;

const SharedReportCard: React.FC<SharedReportCardProps> = (props) => (
    <Card.Card
        key={props.sharedReport.sharedReportId}
        onPress={props.onPress}
        testID={`shared-report-card-${props.sharedReport.reportType}`}
    >
        <Card.CardContent>
            <Card.CardHeader>{reportTypeMessages(props.sharedReport.reportType)}</Card.CardHeader>
            <Card.CardBody2>
                {intl('created', {
                    date: getDateString(props.sharedReport.createdAt, 'date-time'),
                })}
            </Card.CardBody2>
            <Card.CardChip
                title={intl('views', {
                    count: props.sharedReport.views.length,
                    plural: props.sharedReport.views.length !== 1 ? 's' : '',
                })}
            />
        </Card.CardContent>
    </Card.Card>
);

export default React.memo(SharedReportCard);

export type UnloadedSharedReportCardProps = {
    sharedReportId: string;
    medicalProfileId: string;
    onPress?: () => void;
};

export const UnloadedSharedReportCard: React.FC<UnloadedSharedReportCardProps> = (props) => {
    const { isLoadingSharedReport, sharedReport } = useReports({
        medicalProfileId: props.medicalProfileId,
        sharedReportId: props.sharedReportId,
    });

    if (isLoadingSharedReport || !sharedReport) return <Card.CardSkeleton />;

    return <SharedReportCard sharedReport={sharedReport} onPress={props.onPress} />;
};
